class MobileDock extends HTMLElement {
  constructor() {
    super();

    this.isAction = false;

    this.header = document.querySelector('sticky-header');

    this.querySelectorAll('.dock__item[data-action]').forEach((button) => {
      button.addEventListener('click', this.onButtonClick.bind(this));
    });
    document.addEventListener('menudrawer:close', this.hideStickyHeader.bind(this));
    document.addEventListener('searchmodal:close', this.hideStickyHeader.bind(this));
    document.addEventListener('cart:updated', this.onCartUpdated.bind(this));

    this.init();
  }

  init() {
    const delay = window.Shopify && Shopify.designMode ? 1 : parseInt(this.dataset.delay, 10);

    setTimeout(() => {
      this.classList.remove('hidden');
      this.classList.add('is-active');
      requestAnimationFrame(() => {
        document.documentElement.style.setProperty('--mobile-dock-height', `${this.offsetHeight}px`);
      });
    }, delay * 1000);
  }

  onButtonClick(event) {
    event.preventDefault();
    const target = event.currentTarget;
    const delay = this.waitStickyHeader();

    switch (target.dataset.action) {
      case 'cart':
        this.isAction = true;

        const miniCart = document.querySelector('mini-cart');
        setTimeout(() => {
          if (miniCart) {
            miniCart.open();
          } else {
            window.location.href = window.routes?.cart_url || '/cart';
          }
          document.activeElement.blur();
        }, delay);
        break;

      case 'menu':
        this.isAction = true;

        const headerDrawer = document.querySelector('header-drawer');
        setTimeout(() => {
          const summary = headerDrawer?.querySelector('summary');
          if (summary) {
            summary.click();
          }
          document.activeElement.blur();
        }, delay);
        break;

      case 'search':
        this.isAction = true;
        
        document.querySelectorAll('search-modal').forEach((searchModal) => {
          const style = window.getComputedStyle(searchModal);
          if (style.display === 'none') {
            return;
          }

          setTimeout(() => {
            const summary = searchModal.querySelector('summary');
            const input = searchModal.querySelector('input:not([type="hidden"])');
            if (!summary || !input) {
              return;
            }

            summary.click();
            
            input.focus();
          }, delay);
        });
        break;
    }
  }

  hideStickyHeader() {
    if (this.header && window.theme?.config?.mqlSmall && this.isAction && this.header.sticky()) {
      setTimeout(() => {
        this.header.hide();
        this.isAction = false;
      }, 500);
    }
  }

  onCartUpdated(event) {
    try {
      const cart = typeof event.detail?.cart === 'string' ? JSON.parse(event.detail.cart) : event.detail?.cart;
      const itemCount = Number(cart?.item_count || 0);
      this.updateCartCount(itemCount);
    } catch (error) {
      return;
    }
  }

  updateCartCount(itemCount) {
    this.querySelectorAll('[data-mobile-dock-cart-count]').forEach((bubble) => {
      bubble.hidden = itemCount === 0;
      bubble.classList.toggle('mobile-dock__cart-count--dot', itemCount >= 100);
      bubble.setAttribute('aria-label', `${itemCount} cart items`);

      const visibleCount = bubble.querySelector('[aria-hidden="true"]');
      if (visibleCount) {
        visibleCount.textContent = itemCount < 100 ? itemCount : '';
      }
    });
  }

  waitStickyHeader() {
    if (this.header && !this.header.sticky() && !this.isElementVisible(this.header)) {
      this.header.hide();
      setTimeout(() => this.header.reveal());

      return 250;
    }

    return 0;
  }

  isElementVisible(element) {
    const rect = element.getBoundingClientRect(),
        width  = window.innerWidth || document.documentElement.clientWidth,
        height = window.innerHeight || document.documentElement.clientHeight,
        efp    = function (x, y) { return document.elementFromPoint(x, y) };

    if (rect.right < 0 || rect.bottom < 0 || rect.left > width || rect.top > height) {
      return false;
    }

    return (
      element.contains(efp(rect.left,  rect.top))
      || element.contains(efp(rect.right, rect.top))
      || element.contains(efp(rect.right, rect.bottom))
      || element.contains(efp(rect.left,  rect.bottom))
      || element.parentNode.contains(efp(rect.left,  rect.top))
      || element.parentNode.contains(efp(rect.right, rect.top))
      || element.parentNode.contains(efp(rect.right, rect.bottom))
      || element.parentNode.contains(efp(rect.left,  rect.bottom))
    );
  }
}
if (!customElements.get('mobile-dock')) {
  customElements.define('mobile-dock', MobileDock);
}

/* 4PIXELS — unified cart count: header + mobile dock */
(() => {
  if (window.__FPUnifiedCartCount) {
    window.__FPUnifiedCartCount.refresh?.();
    return;
  }

  const BADGE_SELECTOR = '[data-mobile-dock-cart-count],[data-cart-count],#cart-icon-bubble .cart-count-bubble';
  let lastCount = null;
  let refreshTimer = null;
  let observer = null;

  const isArabic = () => {
    const html = document.documentElement;
    return html.dir === 'rtl' || (html.lang || '').toLowerCase().startsWith('ar');
  };

  const getBadges = () => Array.from(new Set(document.querySelectorAll(BADGE_SELECTOR)));
  const setImportant = (el, prop, value) => el.style.setProperty(prop, value, 'important');

  const styleBadge = (bubble, count) => {
    const empty = count <= 0;
    const wide = count >= 100;
    const width = wide ? '28px' : '20px';

    bubble.dataset.fpUnifiedCartCount = 'true';
    bubble.dataset.fpCartEmpty = empty ? 'true' : 'false';
    bubble.dataset.fpCartWide = wide ? 'true' : 'false';

    setImportant(bubble, 'box-sizing', 'border-box');
    setImportant(bubble, 'display', empty ? 'none' : 'inline-flex');
    setImportant(bubble, 'align-items', 'center');
    setImportant(bubble, 'justify-content', 'center');
    setImportant(bubble, 'width', width);
    setImportant(bubble, 'inline-size', width);
    setImportant(bubble, 'min-width', width);
    setImportant(bubble, 'min-inline-size', width);
    setImportant(bubble, 'height', '20px');
    setImportant(bubble, 'block-size', '20px');
    setImportant(bubble, 'min-height', '20px');
    setImportant(bubble, 'min-block-size', '20px');
    setImportant(bubble, 'padding', '0');
    setImportant(bubble, 'margin', '0');
    setImportant(bubble, 'border', '2px solid #FFFFFF');
    setImportant(bubble, 'border-radius', '999px');
    setImportant(bubble, 'background', '#050505');
    setImportant(bubble, 'background-color', '#050505');
    setImportant(bubble, 'color', '#FFFFFF');
    setImportant(bubble, '-webkit-text-fill-color', '#FFFFFF');
    setImportant(bubble, 'box-shadow', '0 3px 10px rgba(0,0,0,.24)');
    setImportant(bubble, 'font-family', '-apple-system,BlinkMacSystemFont,"Segoe UI",Arial,sans-serif');
    setImportant(bubble, 'font-size', '10px');
    setImportant(bubble, 'font-weight', '700');
    setImportant(bubble, 'line-height', '1');
    setImportant(bubble, 'letter-spacing', '0');
    setImportant(bubble, 'text-transform', 'none');
    setImportant(bubble, 'white-space', 'nowrap');
    setImportant(bubble, 'z-index', '20');
    setImportant(bubble, 'pointer-events', 'none');
  };

  const render = (rawCount) => {
    const count = Math.max(0, Number(rawCount) || 0);
    const label = count >= 100 ? '99+' : String(count);
    const aria = isArabic() ? `${count} منتجات في السلة` : `${count} cart items`;
    lastCount = count;

    getBadges().forEach((bubble) => {
      bubble.hidden = count === 0;
      bubble.classList.remove('cart-count-bubble--dot', 'mobile-dock__cart-count--dot');
      bubble.setAttribute('aria-label', aria);
      styleBadge(bubble, count);

      let value = bubble.querySelector('[aria-hidden="true"]');
      if (!value) {
        value = document.createElement('span');
        value.setAttribute('aria-hidden', 'true');
        bubble.insertBefore(value, bubble.firstChild || null);
      }
      if (value.textContent !== label) value.textContent = label;
      setImportant(value, 'color', '#FFFFFF');
      setImportant(value, '-webkit-text-fill-color', '#FFFFFF');
      setImportant(value, 'font-size', '10px');
      setImportant(value, 'font-weight', '700');
      setImportant(value, 'line-height', '1');
      setImportant(value, 'letter-spacing', '0');
    });
  };

  const cartEndpoint = () => {
    const root = window.Shopify?.routes?.root || '/';
    return `${root}cart.js`.replace(/([^:]\/)\/+/, '$1');
  };

  const refresh = async () => {
    try {
      const response = await fetch(cartEndpoint(), {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
        cache: 'no-store'
      });
      if (!response.ok) return;
      const cart = await response.json();
      render(cart.item_count);
    } catch (error) {}
  };

  const scheduleRefresh = (delay = 80) => {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refresh, delay);
  };

  const readEventCount = (event) => {
    try {
      let cart = event?.detail?.cart;
      if (typeof cart === 'string') cart = JSON.parse(cart);
      if (cart && Number.isFinite(Number(cart.item_count))) return Number(cart.item_count);
      if (event?.detail?.item_count != null) return Number(event.detail.item_count);
    } catch (error) {}
    return null;
  };

  const onCartEvent = (event) => {
    const eventCount = readEventCount(event);
    if (eventCount !== null) render(eventCount);
    scheduleRefresh(70);
  };

  const initObserver = () => {
    if (!document.body || observer) return;
    observer = new MutationObserver((mutations) => {
      const added = mutations.some((mutation) => Array.from(mutation.addedNodes || []).some((node) => {
        if (!(node instanceof Element)) return false;
        return node.matches(BADGE_SELECTOR) || Boolean(node.querySelector(BADGE_SELECTOR));
      }));
      if (added && lastCount !== null) requestAnimationFrame(() => render(lastCount));
    });
    observer.observe(document.body, { childList: true, subtree: true });
  };

  const init = () => {
    let initial = 0;
    const first = getBadges()[0];
    if (first) {
      const text = first.querySelector('[aria-hidden="true"]')?.textContent || first.textContent || '';
      const parsed = parseInt(String(text).replace(/[^0-9]/g, ''), 10);
      if (Number.isFinite(parsed)) initial = parsed;
    }
    render(initial);
    initObserver();
    refresh();
  };

  ['cart:updated','cart:change','cart:changed','cart:refresh','cart-drawer:updated','ajaxProduct:added','product:added','quantity:updated']
    .forEach((eventName) => document.addEventListener(eventName, onCartEvent));

  document.addEventListener('shopify:section:load', () => {
    if (lastCount !== null) render(lastCount);
    scheduleRefresh(80);
  });

  document.addEventListener('click', (event) => {
    if (!event.target.closest('cart-remove-button,[data-cart-remove],.cart-remove-button,.quantity__button,[name="minus"],[name="plus"]')) return;
    scheduleRefresh(450);
    setTimeout(refresh, 950);
  }, true);

  document.addEventListener('change', (event) => {
    if (!event.target.matches('[name="updates[]"],input[name="quantity"]')) return;
    scheduleRefresh(450);
  }, true);

  window.addEventListener('pageshow', () => scheduleRefresh(20));
  window.__FPUnifiedCartCount = { refresh, render };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
